"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importDefault(require("react"));
var storybook_1 = require("@eyecons/storybook");
var prop_types_1 = __importDefault(require("prop-types"));
var List = function (_a) {
    var user = _a.user, channel = _a.channel;
    return react_1.default.createElement(storybook_1.Layouts.Container, { className: 'storybook-layouts-space' },
        react_1.default.createElement(storybook_1.Plans.Cards, { user: user, channel: channel }));
};
exports.List = List;
exports.List.propTypes = {
    /**
     * Current user session
     */
    user: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
    }).isRequired,
    /**
     * Current channel session
     */
    channel: prop_types_1.default.shape({
        id: prop_types_1.default.number.isRequired,
        label: prop_types_1.default.string.isRequired
    }).isRequired,
};
exports.List.defaultProps = {};
